import { render, staticRenderFns } from "./form-summernote.vue?vue&type=template&id=50f01a21&"
import script from "./form-summernote.vue?vue&type=script&lang=js&"
export * from "./form-summernote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports